// src/core/cmd/ServerCommand.ts
/**
 * Перечисление поддерживаемых серверных команд.
 */
var ServerCommand;
(function (ServerCommand) {
    /** Показ сообщения */
    ServerCommand["msg"] = "msg";
    /** Перенаправление на URL */
    ServerCommand["redirect"] = "redirect";
    /** Перезагрузить таблицу */
    ServerCommand["reloadTable"] = "reloadTable";
    /** Временно добавить CSS-класс */
    ServerCommand["tmpcss"] = "tmpcss";
    /** Записать HTML в элемент */
    ServerCommand["writeHtml"] = "writeHtml";
    /** Показать элемент */
    ServerCommand["show"] = "show";
    /** Активировать вкладку */
    ServerCommand["activeTab"] = "activeTab";
    /** Скрыть элемент */
    ServerCommand["hide"] = "hide";
    /** Сообщение об ошибке */
    ServerCommand["error"] = "error";
    /** Вызвать callback */
    ServerCommand["callback"] = "callback";
    /** Запустить процесс с отслеживанием */
    ServerCommand["newWatchProcess"] = "new-watch-process";
    /** Открыть форму/панель/диалог */
    ServerCommand["openform"] = "openform";
    /** Вызвать событие */
    ServerCommand["event"] = "event";
    /** Прокрутить к элементу */
    ServerCommand["scrollTo"] = "scrollTo";
})(ServerCommand || (ServerCommand = {}));
var WriteHtmlMode;
(function (WriteHtmlMode) {
    WriteHtmlMode["append"] = "append";
    WriteHtmlMode["prepend"] = "prepend";
    WriteHtmlMode["after"] = "after";
    WriteHtmlMode["replace"] = "replace";
    WriteHtmlMode["remove"] = "remove";
    WriteHtmlMode["setval"] = "setval";
    WriteHtmlMode["setvalCombo"] = "setvalCombo";
    WriteHtmlMode["addClass"] = "addClass";
    WriteHtmlMode["removeClass"] = "removeClass";
    WriteHtmlMode["setattr"] = "setattr";
    WriteHtmlMode["moveUp"] = "moveUp";
    WriteHtmlMode["moveDown"] = "moveDown";
    WriteHtmlMode["default"] = "default";
})(WriteHtmlMode || (WriteHtmlMode = {}));
/** Системные варианты callback */
var ServerCallback;
(function (ServerCallback) {
    ServerCallback["html"] = "cbHtml";
    /** Возврат сообщения через callback */
    ServerCallback["cbMsg"] = "cbMsg";
})(ServerCallback || (ServerCallback = {}));

export { ServerCallback, ServerCommand, WriteHtmlMode };
